<template>
	<div>
		<el-dialog title="" :visible.sync="centerDialogVisible" width="30%" center>
			<div class="align-center">
				<p class="success-img">
					<img src="../../static/popup/success.png" alt="" />
				</p>
				<p class="f24 blod c-3">提交成功</p>
				<p class="red f12 blod">工作人员将在30分钟内联系您～</p>
				<p class="align-center">
					<span class="dialog-btn" @click="closedFun">我知道了</span>
				</p>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		props: {
			centerDialogVisible: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
			}
		},
		methods: {
			closedFun() {
				this.$emit('close', false)
			}
		}
	}
</script>

<style>
	.c-3 {
		color: #333;
	}
	.success-img {
		height: 108px;
	}
	.success-img img {
		height: 100%;
	}
	.dialog-btn {
		display: inline-block;
		width: 234px;
		height: 44px;
		line-height: 44px;
		background: #DF9C03;
		border-radius: 22px;
		font-weight: 500;
		font-size: 16px;
		color: #FFFFFF;
		text-align: center;
		margin-top: 30px;
	}
	.align-center {
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/components/Dialog.vue